import { NLGAction } from '@phrasee/phrasee-typings'

import Alert from 'common/components/alert'
import Button from 'common/components/button'
import LoadingOverlay from 'common/components/LoadingOverlay'
import Overlay from 'common/components/Overlay'

const getGeneratePhrases = () => {
  return [
    `Generating 100s of unique variants…`,
    'Curating variants to match your brand voice…',
    `Discarding non-compliant variants…`,
    'Running Performance Prediction Engine…',
    'Selecting high-performing variants…',
    'Selecting variants for reverification…',
    'Selecting variants to maximise new data points…',
  ]
}
const briefPhrases = [`Creating optimised brief...`]
const topicsPhrases = ['Extracting topics and entities…']

const GENERATION_WAIT_TIMEOUT_MESSAGE =
  'Generation is taking longer than expected. Please try again.'

type Props = {
  isLoading: boolean
  action?: NLGAction
  hasTimedOut?: boolean
  onRetry?: () => void
}

const ContentLoadingOverlay = ({
  isLoading,
  action,
  hasTimedOut = false,
  onRetry,
}: Props) => {
  let phrases: string[] = []
  switch (action) {
    case 'brief':
      phrases = briefPhrases
      break
    case 'topics':
      phrases = topicsPhrases
      break
    default:
      phrases = getGeneratePhrases()
      break
  }

  if (hasTimedOut) {
    return (
      <Overlay bgColor="bg-white" type="local" className="z-100">
        <div
          className="flex flex-col items-center gap-4 max-w-md px-6"
          data-testid="generation-wait-timeout"
        >
          <Alert type="error" showIcon>
            {GENERATION_WAIT_TIMEOUT_MESSAGE}
          </Alert>
          {onRetry && (
            <Button
              variant="primary"
              onClick={onRetry}
              data-testid="generation-wait-retry"
            >
              Retry
            </Button>
          )}
        </div>
      </Overlay>
    )
  }

  return (
    <LoadingOverlay
      isLoading={isLoading}
      phrases={phrases}
      className="z-100"
      overlayType="local"
    />
  )
}

export default ContentLoadingOverlay
